<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Input Kas Keluar</h5>
            </template>
            <b-form @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper">
                    <b-form-group label="Nominal">
                        <b-input-group prepend="Rp.">
                            <b-form-input v-model="input.nominalKasKeluar" name="nominalKasKeluar" required></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group label="Keterangan">
                        <b-form-textarea v-model="input.keteranganKasKeluar" name="keteranganKasKeluar" required></b-form-textarea>
                    </b-form-group>
                </div>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="kasKeluarSubmitBtn" variant="pgiBtn">Kirim</b-button>
                </div>
            </b-form>
        </b-card>
        <ModalConfirm id="modal-confirm-input" title="Confirm Input Kas Keluar" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menginput kas keluar ini?" @submit="onSubmit" />
    </div>
</template>

<script>
export default {
    name: 'input-kas-keluar',
    data(){
        return{
            initStatus: 0,
            isBusy: false,
            isSubmitting: false,
            input: {
                cabangKasKeluar: null,
                nominalKasKeluar: null,
                keteranganKasKeluar: ""
            },
            cabangOption: []
        }
    },
    methods:{
        
        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0

            let getActiveCabang = localStorage.getItem("activeCabangId")
            this.input.cabangKasKeluar = getActiveCabang

            Promise.all([getActiveCabang]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        onSubmit() {
            //back to list kas masuk
            let payload = new FormData()
            
            let nominal = this.$helper.removeThousandSeparator(this.input.nominalKasKeluar)

            payload.append("cabangId", this.input.cabangKasKeluar)
            payload.append("nominal", nominal)
            payload.append("keterangan", this.input.keteranganKasKeluar)

            //----------------- Submit Semua Data -----------------
            
            this.isSubmitting = true
            
            this.$axios.post("cabang/kas/keluar/", payload).then(response => {
                this.$helper.setFlash(`Input Kas Keluar telah berhasil!`)
                let path = this.$route.path.split('/')
                path.pop()
                path = path.join("/") 
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        openModalConfirm(){
            this.$bvModal.show("modal-confirm-input")
        }
    },
    watch: {
        "input.nominalKasKeluar": function(newValue) {
            let cleanValue = this.$helper.changeToValue(newValue);
            const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.nominalKasKeluar = result);
        },
    },
    created(){
        this.init()
    }
}
</script>
